module.exports = __webpack_public_path__ + "static/media/es.5268537b.svg";